"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var Telemetry_1 = require("Telemetry");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ActionsHelper_1 = require("Project/Service/Actions/ActionsHelper");
var className = "more-actions-dropdown";
var MoreActionsDropdown = (function (_super) {
    __extends(MoreActionsDropdown, _super);
    function MoreActionsDropdown() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.isTooltipLocked = false;
        _this.handleClick = function () {
            _this.isTooltipLocked = true;
            _this.actionsListElement = _this.renderActionsListElement();
        };
        _this.handleClose = function () {
            _this.isTooltipLocked = false;
        };
        return _this;
    }
    MoreActionsDropdown.prototype.render = function () {
        var _a;
        return (react_1.default.createElement(kaleidoscope_2.OptionMenu, { className: className, onClose: this.handleClose, button: react_1.default.createElement(kaleidoscope_2.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), size: kaleidoscope_2.ButtonSize.Small, onClick: this.handleClick, tooltip: {
                    content: "More actions",
                    position: kaleidoscope_1.TooltipPosition.Bottom,
                    className: (0, classnames_1.default)("".concat(className, "__tooltip"), (_a = {},
                        _a["".concat(className, "__tooltip--hidden")] = this.isTooltipLocked,
                        _a)),
                }, className: "".concat(className, "__button"), disabled: this.props.disabled, disabledReason: this.props.disabledReason }) }, this.actionsListElement));
    };
    MoreActionsDropdown.prototype.renderActionsListElement = function () {
        var _this = this;
        return this.actionsList.map(function (item) {
            var optionMenuItemProps = {
                key: item.getDisplayName(_this.props.project),
                onClick: function () { return _this.onClickWrapper(item); },
                className: "".concat(className, "__item--").concat(lodash_1.default.kebabCase(item.name)),
                children: item.getDisplayName(_this.props.project),
            };
            var reactIcon = (0, ActionsHelper_1.getReactIcon)(item.name);
            if (reactIcon) {
                optionMenuItemProps.icon = reactIcon;
            }
            if (item.customMenuComponent) {
                return react_1.default.createElement(item.customMenuComponent, __assign({}, optionMenuItemProps));
            }
            else if (item.name !== "Delete") {
                return react_1.default.createElement(kaleidoscope_2.OptionMenuItem, __assign({}, optionMenuItemProps));
            }
            else {
                return (react_1.default.createElement(react_1.default.Fragment, { key: "separator-group" },
                    react_1.default.createElement(kaleidoscope_2.OptionMenuSeparator, { key: "separator" }),
                    react_1.default.createElement(kaleidoscope_2.OptionMenuItem, __assign({}, optionMenuItemProps, { destructive: true }))));
            }
        });
    };
    Object.defineProperty(MoreActionsDropdown.prototype, "actionsList", {
        get: function () {
            return this.props.actionsList;
        },
        enumerable: false,
        configurable: true
    });
    MoreActionsDropdown.prototype.onClickWrapper = function (item) {
        if (item.name === "Clone") {
            return item.onClick(this.props.project, null, Telemetry_1.ProjectCreatedCloneOrigin.EditorProjectOptionsMenu);
        }
        else {
            return item.onClick(this.props.project, null);
        }
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], MoreActionsDropdown.prototype, "isTooltipLocked", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof react_1.default !== "undefined" && react_1.default.ReactNode) === "function" ? _a : Object)
    ], MoreActionsDropdown.prototype, "actionsListElement", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], MoreActionsDropdown.prototype, "handleClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], MoreActionsDropdown.prototype, "handleClose", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], MoreActionsDropdown.prototype, "onClickWrapper", null);
    MoreActionsDropdown = __decorate([
        mobx_react_1.observer
    ], MoreActionsDropdown);
    return MoreActionsDropdown;
}(react_1.default.Component));
exports.default = MoreActionsDropdown;
